var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-wrapper",style:(_vm.wrapperStyle)},[_c('div',{staticClass:"btn",style:(_vm.buttonStyle),on:{"click":_vm.onButtonClick}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }